"use client";

import React, { useMemo } from "react";

import Box from "@mui/material/Box";

import {
	NotificationItem,
	NotificationVariant,
} from "#src/components/notifications/notification-item.tsx";

import { NotificationResponse } from "@onair/repositories";
import Stack from "@mui/material/Stack";

// ----------------------------------------------------------------------

interface PropTypes {
	items: NotificationResponse[];
	variant?: NotificationVariant;
}

export const NotificationList = ({
	items,
	variant = NotificationVariant.DEFAULT,
}: PropTypes) => {
	const renderItems = useMemo(() => {
		return (
			<>
				{items.map((notification) => (
					<Box
						component="li"
						key={notification.id}
						sx={{ display: "flex" }}
					>
						<NotificationItem
							variant={variant}
							notification={notification}
						/>
					</Box>
				))}
			</>
		);
	}, [items, variant]);

	if (variant === NotificationVariant.DEFAULT) {
		return (
			<Stack direction="column" spacing={2}>
				{renderItems}
			</Stack>
		);
	}

	return (
		<>
			<Box component="ul">{renderItems}</Box>
		</>
	);
};
